import type { FormSpec } from "./formSpec"

export function getEmptyValues(spec: FormSpec): Record<string, unknown> {
    const out: Record<string, unknown> = {}
    for (const key in spec.fields) {
        const def = spec.fields[key]
        if (!def) continue
        if (def.type === "checkbox") out[key] = false
        else out[key] = ""
    }
    return out
}

export function getInitialValues(spec: FormSpec): Record<string, unknown> {
    const emptyOnMount = spec.form?.emptyOnMount === true
    if (emptyOnMount) return getEmptyValues(spec)
    return { ...getEmptyValues(spec), ...(spec.defaults || {}) }
}